/**
 * btg-ai-agent – Lightweight AI Agent SDK for existing web applications
 *
 * Browser-side AI code execution with AST-based security,
 * multi-provider support, and generic UI awareness.
 */

// ── Core: Code Execution & Security ───────────────────────────────────────────
export { createEvaluate } from "./evaluate";
export type { EvaluateOptions } from "./evaluate";
export { roundValues } from "./roundValues";

export { validateAiCode } from "./validateAiCode";
export type { ValidationResult } from "./validateAiCode";

// ── Core: Runtime Type Resolution ─────────────────────────────────────────────
export { resolveRuntimeValues } from "./resolveRuntimeValues";

// ── Core: UI Awareness ────────────────────────────────────────────────────────
export { getCurrentUIState } from "./getCurrentUIState";
export type { UIStateOptions } from "./getCurrentUIState";

// ── Core: UI Interaction (data-* based) ───────────────────────────────────────
export { createUIInteractionHelpers, sanitizeString, createRateLimiter, sleep } from "./uiInteraction";
export type { UIInteractionHelpers, UIInteractionOptions } from "./uiInteraction";

// ── Core: Viewport Screenshot ─────────────────────────────────────────────────
export { captureScreen, consumePendingScreenshots } from "./captureScreen";
export type { PendingScreenshot } from "./captureScreen";

// ── Provider Factory ──────────────────────────────────────────────────────────
export { createAiModel } from "./AiProviderFactory";
export type { AiProviderFactoryOptions, AiProviderName } from "./AiProviderFactory";

// ── React Hook ────────────────────────────────────────────────────────────────
export { useAiAgent, createMessage } from "./useAiAgent";
export type {
  AiAgentOptions,
  AiAgentMessage,
  AiFenceRenderAspectRatio,
  AiFenceRenderImageSize,
  AiFenceRenderRequest,
  AiFenceRenderResult,
} from "./useAiAgent";

// ── Speech (Web Speech API) ───────────────────────────────────────────────────
export { useSpeechToText, useTextToSpeech, stripForSpeech } from "./useSpeech";
export type { SpeechToTextResult, TextToSpeechResult } from "./useSpeech";

